export default function AboutUs() {
  return (
    <section id="nosotros" className="relative py-16 md:py-32 px-4 md:px-8 bg-white overflow-hidden">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 md:gap-16 items-center">
          {/* Contenido Izquierdo */}
          <div className="space-y-6 md:space-y-8">
            <div className="inline-block border border-gray-600 text-gray-400 px-3 md:px-4 py-1.5 md:py-2 rounded-lg text-xs md:text-sm" style={{ fontFamily: 'Inter, sans-serif' }}>
              (Quiénes Somos)
            </div>

            <div>
              <h2 className="text-white font-bold text-3xl md:text-5xl mb-2 leading-tight" style={{ fontFamily: 'Poppins, sans-serif' }}>
                Tu electricista de
              </h2>
              <h2 className="font-bold text-3xl md:text-5xl mb-4 leading-tight" style={{ fontFamily: 'Poppins, sans-serif' }}>
                <span className="text-[#FFD700]">confianza</span> <span className="text-white">y asesor</span>
              </h2>
            </div>

            <p className="text-gray-400 text-base md:text-lg leading-relaxed" style={{ fontFamily: 'Inter, sans-serif', lineHeight: '1.9' }}>
              Con más de 7 años de experiencia, somos electricistas certificados especializados en instalaciones residenciales y comerciales. Nuestro valor diferencial es el <strong className="text-white">asesoramiento personalizado</strong>: te explicamos cada opción, te ayudamos a elegir la mejor solución y ejecutamos el trabajo con garantía total.
            </p>

            <p className="text-gray-400 text-base md:text-lg leading-relaxed" style={{ fontFamily: 'Inter, sans-serif', lineHeight: '1.9' }}>
              Además, somos especialistas en <strong className="text-white">diseño de iluminación interior</strong> con tiras LED, focos y sistemas regulables que transforman cualquier espacio.
            </p>

            <a href="#contacto" className="inline-flex items-center text-[#FFD700] hover:text-[#FFC700] font-medium transition-colors duration-300 cursor-pointer text-sm md:text-base">
              Solicitar asesoramiento gratuito <i className="ri-arrow-right-line ml-2"></i>
            </a>

            {/* Métricas */}
            <div className="grid grid-cols-3 gap-4 md:gap-6 pt-6 md:pt-8">
              <div>
                <div className="text-[#FFD700] font-extrabold text-3xl md:text-5xl mb-1 md:mb-2" style={{ fontFamily: 'Poppins, sans-serif' }}>
                  7+
                </div>
                <div className="text-gray-500 text-xs md:text-sm uppercase tracking-wide">
                  Años de experiencia
                </div>
              </div>
              <div>
                <div className="text-[#FFD700] font-extrabold text-3xl md:text-5xl mb-1 md:mb-2" style={{ fontFamily: 'Poppins, sans-serif' }}>
                  754+
                </div>
                <div className="text-gray-500 text-xs md:text-sm uppercase tracking-wide">
                  Proyectos completados
                </div>
              </div>
              <div>
                <div className="text-[#FFD700] font-extrabold text-3xl md:text-5xl mb-1 md:mb-2" style={{ fontFamily: 'Poppins, sans-serif' }}>
                  98%
                </div>
                <div className="text-gray-500 text-xs md:text-sm uppercase tracking-wide">
                  Satisfacción cliente
                </div>
              </div>
            </div>
          </div>

          {/* Contenido Derecho - Imágenes */}
          <div className="relative h-[500px] md:h-[600px] hidden lg:block">
            <div className="absolute top-0 left-0 w-72 h-72 rounded-3xl overflow-hidden shadow-2xl">
              <img
                src="https://public.readdy.ai/ai/img_res/f18ab6eb5988f42a5834ae4f657965d3.jpg"
                alt="Asesoramiento eléctrico profesional"
                className="w-full h-full object-cover object-top"
              />
            </div>

            <div className="absolute bottom-0 right-0 w-80 h-[420px] rounded-3xl overflow-hidden shadow-2xl">
              <img
                src="https://readdy.ai/api/search-image?query=beautiful%20interior%20room%20with%20custom%20LED%20strip%20lighting%20design%2C%20warm%20glowing%20LED%20strips%20along%20ceiling%20and%20walls%20creating%20stunning%20ambient%20atmosphere%2C%20modern%20living%20space%20with%20professional%20LED%20illumination%2C%20architectural%20interior%20photography%20with%20rich%20warm%20golden%20tones%2C%20elegant%20home%20lighting%20design&width=400&height=550&seq=about-led-2&orientation=portrait"
                alt="Diseño de iluminación LED interior"
                className="w-full h-full object-cover object-top"
              />
            </div>

            {/* Badge flotante */}
            <div className="absolute top-1/2 right-0 transform translate-x-4 -translate-y-1/2 bg-[#FFD700] text-black px-5 py-4 rounded-2xl shadow-2xl shadow-[#FFD700]/40 z-10">
              <div className="text-2xl font-extrabold" style={{ fontFamily: 'Poppins, sans-serif' }}>24/7</div>
              <div className="text-xs font-semibold uppercase tracking-wide">Urgencias</div>
            </div>
          </div>

          {/* Imágenes apiladas para móvil */}
          <div className="grid grid-cols-2 gap-4 lg:hidden">
            <div className="rounded-2xl overflow-hidden shadow-xl h-64">
              <img
                src="https://readdy.ai/api/search-image?query=professional%20electrician%20giving%20advice%20to%20homeowner%20about%20electrical%20installation%2C%20expert%20technician%20explaining%20electrical%20panel%20options%20in%20modern%20home%2C%20friendly%20consultation%20scene%20with%20professional%20tools%2C%20warm%20natural%20lighting%2C%20trust%20and%20expertise%20atmosphere&width=400&height=400&seq=about-advice-1&orientation=squarish"
                alt="Asesoramiento eléctrico profesional"
                className="w-full h-full object-cover object-top"
              />
            </div>

            <div className="rounded-2xl overflow-hidden shadow-xl h-64">
              <img
                src="https://readdy.ai/api/search-image?query=beautiful%20interior%20room%20with%20custom%20LED%20strip%20lighting%20design%2C%20warm%20glowing%20LED%20strips%20along%20ceiling%20and%20walls%20creating%20stunning%20ambient%20atmosphere%2C%20modern%20living%20space%20with%20professional%20LED%20illumination%2C%20architectural%20interior%20photography%20with%20rich%20warm%20golden%20tones%2C%20elegant%20home%20lighting%20design&width=400&height=550&seq=about-led-2&orientation=portrait"
                alt="Diseño de iluminación LED interior"
                className="w-full h-full object-cover object-top"
              />
            </div>

            {/* Badge para móvil */}
            <div className="col-span-2 flex justify-center -mt-6">
              <div className="bg-[#FFD700] text-black px-6 py-3 rounded-2xl shadow-2xl shadow-[#FFD700]/40">
                <div className="text-xl font-extrabold inline-block mr-2" style={{ fontFamily: 'Poppins, sans-serif' }}>24/7</div>
                <div className="text-xs font-semibold uppercase tracking-wide inline-block">Urgencias</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}